
import React from 'react';
import { Button } from '@/components/ui/button';
import { Clock, Utensils, Beer, PawPrint } from 'lucide-react';
import { useScreenSize } from '@/hooks/use-mobile';

type FilterBarProps = {
  filters: {
    openNow: boolean;
    hasFood: boolean;
    petFriendly: boolean;
    servesAlcohol: boolean;
  };
  setFilters: React.Dispatch<React.SetStateAction<{
    openNow: boolean;
    hasFood: boolean;
    petFriendly: boolean;
    servesAlcohol: boolean;
  }>>;
};

const FilterBar: React.FC<FilterBarProps> = ({
  filters,
  setFilters
}) => {
  const { isMobile } = useScreenSize();

  const toggleFilter = (key: keyof typeof filters) => {
    setFilters(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const filterItems = [{
    key: 'openNow' as const,
    icon: Clock,
    label: 'Open',
    active: filters.openNow
  }, {
    key: 'hasFood' as const,
    icon: Utensils,
    label: 'Food',
    active: filters.hasFood
  }, {
    key: 'petFriendly' as const,
    icon: PawPrint,
    label: 'Pets',
    active: filters.petFriendly
  }, {
    key: 'servesAlcohol' as const,
    icon: Beer,
    label: 'Drinks',
    active: filters.servesAlcohol
  }];

  return (
    <div className="w-full shadow-soft border-b border-border/30 py-2 sm:py-3 bg-background">
      <div className="w-full px-3 sm:px-4 md:px-6">
        <div className="flex items-center justify-start gap-1.5 sm:gap-2 md:gap-3 overflow-x-auto scrollbar-warm">
          {filterItems.map(item => (
            <Button
              key={item.key}
              variant={item.active ? "default" : "outline"}
              size="sm"
              onClick={() => toggleFilter(item.key)}
              className={`
                flex items-center gap-1.5 whitespace-nowrap flex-shrink-0 transition-all duration-300 hover-lift
                ${isMobile ? 'h-9 px-3 text-xs' : 'h-10 px-4 text-sm'}
                ${item.active 
                  ? 'bg-peach-orange hover:bg-peach-orange/90 text-white shadow-warm font-medium border-border' 
                  : 'border-peach-orange hover:bg-peach-orange/10 hover:text-sunset-dark hover:border-peach-orange/40 hover:shadow-soft'
                }
              `}
            >
              <item.icon className={`flex-shrink-0 ${isMobile ? 'h-3.5 w-3.5' : 'h-4 w-4'}`} />
              <span className="font-medium">{item.label}</span>
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
